module.exports = __webpack_public_path__ + "img/8.5d4befe2.gif";